import { useGetAll } from './useGetAll'

export const base = {
  getAll: useGetAll,
}
